import React from 'react';
import './DropDownMenu.scss';

export const DropDownMenu = React.memo(({children}) => (
	<div className="dropdown-menu">
		{ children }
	</div>
));